import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { PropType } from 'vue'
import { isLargeViewPort } from '@remote/utils/base'


export default /*#__PURE__*/_defineComponent({
  props: {
  close: {
    type: Function as PropType<(...args: any) => void>,
    required: true,
  },
  isShow: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (!_unref(isLargeViewPort)() || __props.isShow)
      ? (_openBlock(), _createElementBlock("div", _mergeProps({
          key: 0,
          class: { 'pop-wrapper': true, 'is-mounted': __props.isShow },
          onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.close(undefined)))
        }, _ctx.$attrs), [
          _renderSlot(_ctx.$slots, "default")
        ], 16))
      : _createCommentVNode("", true)
  ]))
}
}

})